// Приветственное письмо (035: contracts/api.md, «Маршруты»; data-model.md, «Состояния письма для окна
// и карточки»): последнее письмо пользователя для окна после создания и карточки. Токена и текста
// письма нет — только состояние, причина и адрес, который администратор и так видит в карточке.
import { z } from '../kernel/zod.ts';
import { IdSchema, TimestampSchema } from '../kernel/common.ts';
import {
  MailMessageReasonSchema,
  MailMessageStateSchema,
  ShadowReasonCodeSchema,
  mailWaitingReasons,
} from './message.ts';

export const WelcomeLetterSchema = z.object({
  id: IdSchema,
  state: MailMessageStateSchema,
  waiting: z.enum(mailWaitingReasons).nullable(),
  /** Причина ожидания или ошибки: код и слова платформы или каталога. */
  reason: MailMessageReasonSchema.nullable(),
  /** Причины тени последней попытки; пусто — не тень. */
  shadow: z.array(ShadowReasonCodeSchema),
  /** Почта при сборке письма. */
  recipient: z.string(),
  createdAt: TimestampSchema,
  sentAt: TimestampSchema.nullable(),
});
export type WelcomeLetter = z.infer<typeof WelcomeLetterSchema>;

/** GET /api/users/{id}/welcome: письма ещё нет (подписчик не успел) — null. */
export const WelcomeLetterResponseSchema = z.object({ letter: WelcomeLetterSchema.nullable() });
export type WelcomeLetterResponse = z.infer<typeof WelcomeLetterResponseSchema>;

/** POST /api/users/{id}/welcome: 202, номер нового письма (номер события). */
export const SendWelcomeResponseSchema = z.object({ letterId: IdSchema });
export type SendWelcomeResponse = z.infer<typeof SendWelcomeResponseSchema>;
